import { Auth } from "../../../../api/Channel/Auth";
import { getUserData, loginAxios } from "auth/hooks/useLogin";
import { errorMsg } from "helper/message";
import { LOCAL_STORAGE, setDataSession } from "helper/session";
import { removeCmsToken, setCmsToken, setUserSession } from "helper/user";
import _ from "lodash";
import { UAA_PATH } from "modules/Channel/configs/constant";
import {
  getMenuItemsByRoles,
  menus,
} from "modules/Channel/configs/navigationConfig";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { setCurrentBizzApp, setCurrentMenuApp } from "redux/bizzAppReducer";
import store from "store";

const Redirect = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const search = location.search;
  const params = new URLSearchParams(search);

  const username = params.get("str1");
  const passwordEncoded = params.get("str2").split(" ");

  const password = atob(
    passwordEncoded.length >= 2
      ? passwordEncoded.join("+")
      : passwordEncoded.join("")
  );

  const password1 = password.slice(5, 8);
  const password2 = password.slice(18, password.length);

  const path = params.get("path");

  const newToken = {
    username: username,
    password: password1 + password2,
    grant_type: "password",
  };

  setDataSession(LOCAL_STORAGE, "isLogin", false);
  dispatch(setCurrentMenuApp([]));
  removeCmsToken();
  store.clearAll();

  const loginAccount = async () => {
    try {
      const loginDetail = await loginAxios(newToken);
      const { data } = loginDetail;
      setCmsToken(data?.data);
      setDataSession(LOCAL_STORAGE, "isLogin", true);
      await getAccountInfo();
      const {
        data: { data: currentRoleData },
      } = await Auth.currentRoleUser();
      if (
        !_.isNil(_.get(currentRoleData, "code")) &&
        !_.isEmpty(_.get(currentRoleData, "code"))
      ) {
        const chosenBizzAppMenu = getMenuItemsByRoles(
          { key: "", label: "" },
          menus,
          currentRoleData
        ).children;
        dispatch(setCurrentMenuApp(chosenBizzAppMenu || []));
        // setDataSession(LOCAL_STORAGE, KEY_ROLE_BIZZ_UAA, currentRoleData);
      }
      navigate(`${UAA_PATH}/${path}`);
    } catch (err) {
      errorMsg(err, "Có lỗi");
      dispatch(setCurrentBizzApp(null));
      localStorage.clear();
      sessionStorage.clear();
      navigate("/login");
    }
  };

  const getAccountInfo = async () => {
    const userDetail = await getUserData();
    setUserSession(userDetail?.data?.data);
  };

  useEffect(() => {
    loginAccount();
  }, []);

  return <>Redirect...</>;
};

export default Redirect;
